module.exports = __webpack_public_path__ + "img/chicos-movil.51b9d7e0.png";